window.site = (window.site || {});

/**
 * Init Mobile Menu related scripts
 * @class Site
 * @static
 */
site.MenuMobile = (function MenuMobile() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $trigger = document.querySelectorAll('.header-burger-menu');
    const $triggerClose = document.querySelector('.navigation-close');
    const $triggerOverlay = document.querySelector('#page-container.is-active');


    const $main = document.querySelector('#page-container');
    const $menu = document.querySelector('.navigation-mobile');

    const $nav = document.querySelector('.header');



    if ($trigger && $triggerClose) {

      $trigger.forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();


          $main.classList.toggle('is-active');
          $menu.classList.toggle('is-active');
          disableScroll();
        });
      });

      if ($triggerOverlay) {
        $triggerOverlay.addEventListener('click', (e) => {
          e.preventDefault();

          $main.classList.toggle('is-active');
          $menu.classList.toggle('is-active');

          enableScroll();
        });
      }

      $triggerClose.addEventListener('click', (e) => {
        e.preventDefault();

        $main.classList.toggle('is-active');
        $menu.classList.toggle('is-active');

        enableScroll();
      });

    };

    if ($nav) {
      activateMenuFollow($nav);
    }

    return true;

  };

  // left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = {37: 1, 38: 1, 39: 1, 40: 1};

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

// modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () { supportsPassive = true; }
    }));
  } catch(e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

// call this to Disable
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

// call this to Enable
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  const activateMenuFollow = function (nav) {
    const buffer = 10;
    let lastScrollTop = 0;

    function checkScroll() {

      let st = document.documentElement.scrollTop;

      if( st > 0 ){
        nav.classList.add('is-active');
      } else {
        nav.classList.remove('is-active');
      }

      if (st > lastScrollTop){
        // downscroll code
        nav.classList.add( "hide-nav-bar" );
      } else if( st < ( lastScrollTop - buffer ) ){
        // upscroll code
        nav.classList.remove( "hide-nav-bar" );
      }

      if(st <= 15){
        nav.classList.remove( "hide-nav-bar" );
      }

      lastScrollTop = st;
    }

    window.addEventListener("scroll", () => {
      checkScroll();
    });
    checkScroll();
  };

  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
